import { Breadcrumb, Button, Col, Divider, Row, Steps, Table } from "antd";
import Title from "antd/es/typography/Title";
import { Link } from "react-router-dom";

import { EnvironmentOutlined } from '@ant-design/icons';

import Loading from "../../../components/Loading";
import useVerifyGiveaway from "./useVerifyGiveaway";
import ExportData from "./Steps/ExportData";
import ProcessData from "./Steps/ProcessData";
import { FaLink } from "react-icons/fa";
import ModalWinners from "../HoldGiveaway/components/ModalWinners";

export default function VerifyGiveaway() {
    const {
        giveaway,
        isLoadingGiveaway,
        currentStep,
        handleClickExportStep,
        handleClickImportStep,
        handleClickNextStep,
        handleClickPreviousStep,
        alreadyGeneratedTicketsFile,
        panelUserGeneratedParcitipantsFile,
        handleTicketsFileGenerated,
        enableResultStep,
        refreshGiveaway,
        tableData,
        handleClickViewAwards,
        columns,
        handleCloseModalWinners,
        showWinners,
        awardsWithWinners,
        lastGiveawayHistory,
        getOneWinnerByGiveawayAwardAndAttempt,
        rulesGiveaway,
    } = useVerifyGiveaway();

    return (
        <Loading loading={isLoadingGiveaway}>
            <Row>
                <Col>
                    <Title level={3}><EnvironmentOutlined style={{ fontSize: 35, marginRight: 10 }} /> Processamento de Sorteio (Loteria federal)</Title>
                    <Breadcrumb
                        items={[
                            {
                                title: <Link to='/sorteios/geral'>Sorteios</Link>,
                            },
                            {
                                title: ' Processamento de Sorteio',
                            }
                        ]}
                    />
                </Col>
                <Divider />
            </Row>

            <Row
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 16,
                }}
            >
                <div
                    style={{
                        width: '65%'
                    }}
                >

                    <Steps
                        current={currentStep}
                        onChange={() => { }}
                        items={[
                            {
                                title: "Fechar sorteio",
                                onClick: handleClickExportStep,
                            },
                            {
                                title: "Processar bilhetes",
                                onClick: alreadyGeneratedTicketsFile ? handleClickImportStep : undefined,
                                disabled: !alreadyGeneratedTicketsFile,
                            },
                            // {
                            //     title: "Resultado",
                            //     disabled: enableResultStep,
                            //     onClick: !enableResultStep ? handleClickResultStep : undefined,
                            // }
                        ]}
                    />
                </div>
            </Row>

            {
                currentStep === 0 && (
                    <ExportData
                        giveaway={giveaway}
                        lastGiveawayHistory={lastGiveawayHistory}
                        panelUserGeneratedParticipantsFile={panelUserGeneratedParcitipantsFile}
                        onTicketsFileGenerated={handleTicketsFileGenerated}
                        key={giveaway?.id}
                    />
                )
            }

            {
                currentStep === 1 && (
                    <ProcessData
                        giveaway={giveaway}
                        refreshGiveaway={refreshGiveaway}
                        onClickShowTicketWinner={getOneWinnerByGiveawayAwardAndAttempt}
                        key={giveaway?.id}
                    />
                )
            }

            {/* {
                currentStep === 2 && (
                    <ResultData
                        giveaway={giveaway}
                        key={giveaway?.id}
                    />
                )
            } */}

            <Row
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 16,
                }}
            >
                <Button
                    type='default'
                    htmlType='button'
                    disabled={currentStep === 0} // || isSubmiting
                    // loading={isSubmiting}
                    onClick={handleClickPreviousStep}
                >
                    Anterior
                </Button>

                <Button
                    type='default'
                    htmlType='button'
                    disabled={currentStep === 2 || !alreadyGeneratedTicketsFile || enableResultStep}
                    onClick={handleClickNextStep}
                >
                    Próximo
                </Button>
            </Row>
            <Divider />
            <Row style={{ marginTop: 20, justifyContent: 'space-between', alignItems: 'center' }}>
                <Col>
                    <Title level={4}>Histórico do sorteio</Title>
                </Col>
                <Col>
                    <Button type="primary" icon={<FaLink />} onClick={handleClickViewAwards}>Ver prêmios</Button>
                </Col>
                <Col span={24}>
                    <Table

                        columns={columns}
                        dataSource={tableData}
                        loading={isLoadingGiveaway}
                        scroll={{ x: 'max-content' }}
                        style={{
                            marginTop: 0,
                        }}
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: event => { }, // click row
                                onDoubleClick: event => { }, // double click row
                                onContextMenu: event => { }, // right button click row
                                onMouseEnter: event => { }, // mouse enter row
                                onMouseLeave: event => { },
                            }
                        }}
                        pagination={{
                            position: ['topRight', 'bottomRight'],
                            total: tableData.length,
                            showTotal: (total, range) => `Mostrando ${range[0]}-${range[1]} de ${total} ganhadores`,
                            showSizeChanger: true,
                            pageSize: 50,
                            pageSizeOptions: ["50", "100"],
                        }}
                    />
                </Col>
            </Row>
            <ModalWinners
                rules={rulesGiveaway}
                onClose={handleCloseModalWinners}
                open={showWinners}
                awardsWithWinners={awardsWithWinners || []}
                giveawayTitle={giveaway?.description}
            />
        </Loading>
    )
}
